import { H1 } from 'src/Components/Typography';

export const NotFoundPage = () => {
  return (
    <div className='w-full min-h-screen flex flex-col items-center justify-center'>
      <H1>404 Not Found</H1>
    </div>
  );
};
